import { Observable, first } from 'rxjs';

declare module 'rxjs' {
  interface Observable<T> {
    once(predicate?: (value: T) => boolean): Observable<T>;
    subscribeOnce(
      next?: (value: T) => void,
      error?: (err: any) => void,
      complete?: () => void,
    ): ReturnType<Observable<T>['subscribe']>;
    subscribeOnceWhere(
      predicate: (value: T) => boolean,
      next?: (value: T) => void,
      error?: (err: any) => void,
      complete?: () => void,
    ): ReturnType<Observable<T>['subscribe']>;
  }
}

Observable.prototype.once = function <T>(
  this: Observable<T>,
  predicate?: (value: T) => boolean,
): Observable<T> {
  return this.pipe(first(predicate));
};

Observable.prototype.subscribeOnce = function <T>(
  this: Observable<T>,
  next?: (value: T) => void,
  error?: (err: any) => void,
  complete?: () => void,
) {
  return this.once().subscribe({ next, error, complete });
};

Observable.prototype.subscribeOnceWhere = function <T>(
  this: Observable<T>,
  predicate: (value: T) => boolean,
  next?: (value: T) => void,
  error?: (err: any) => void,
  complete?: () => void,
) {
  return this.once(predicate).subscribe({ next, error, complete });
};
